import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import DateAdapter from '@mui/lab/AdapterMoment'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

import Layout from './components/layout/Layout'
import SurveyForm from './components/survey-form/SurveyForm'

const App = () => {
  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <Layout>
        <Router>
          <Switch>
            <Route path='/' exact component={SurveyForm} />
          </Switch>
        </Router>
      </Layout>
    </LocalizationProvider>
  )
}

export default App
